export enum AddPointSuccess {
  SUCCESS = 200,
}

export enum AddPointError {
  VALUE_LESS_THAN_OR_EQUAL_TO_ZERO = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  RECIPIENT_NOT_FOUND = 404,
  INSUFFICIENT_BALANCE = 500,
}
export const AddPointSuccessDefined = {
  [AddPointSuccess.SUCCESS]: {
    message: 'Thêm điểm thành công',
  },
};

export const AddPointErrorDefined = {
  [AddPointError.VALUE_LESS_THAN_OR_EQUAL_TO_ZERO]: {
    message: `Số điểm không thể nhỏ hơn hoặc bằng 0, Số dư không đủ`,
  },
  [AddPointError.UNAUTHORIZED]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [AddPointError.FORBIDDEN]: {
    message: 'Tài khoản không có quyền truy cập',
  },
  [AddPointError.RECIPIENT_NOT_FOUND]: {
    message: `Không tìm thấy người dùng, Không thể lấy thông tin người nhận`,
  },
  [AddPointError.INSUFFICIENT_BALANCE]: {
    message: 'Đã có lỗi xảy ra, vui lòng thử lại sau',
  },
};
